import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import CourseCombo from '../combos/CourseCombo';
import TeacherCombo from '../combos/TeacherCombo';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Container, Form, Row } from 'react-bootstrap';
import StudentCombo from '../combos/StudentCombo';
import { responsivePropType } from 'react-bootstrap/esm/createUtilityClasses';


export default function StudentTiming(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [comboVisible, setComboVisible] = useState(false);
  const [timingVisible, setTimingVisible] = useState(false);
  const [btnVisible, setBtnVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [student, setStudent] = useState(null);
  const [schoolClass, setSchoolClass] = useState(null);

  const [timings, setTimings] = useState([]);
  const [dayParts, setDayParts] = useState([]);

  useEffect(() => {
    var user = util.getCurrentUser();
    if(user.Role === 5){
      setTimingVisible(true);
      setComboVisible(false);
      loadTimings(user.UserId);
    }
    else if(user.Role === 6){
      setComboVisible(true);
    }
  }, []);

  const loadTimings = function(stuId){
      setLoading(true);
      var params = {login:util.getTrustedUser(), studentId:stuId};
      var url = config.Server+`/school/timing/student/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var sc = response.schoolClass;
                  setSchoolClass(sc);
                  response = response.timings;
                  console.log("resopnse is> ", response[0].dayItems);
                  var dp = [];
                  for(var i=0;i<response[0].dayItems.length;i++){
                    dp.push({index:response[0].dayItems[i].timeIndex, title:response[0].dayItems[i].timePart})
                  }
                  setDayParts(dp);
                  setTimings(response);
                  setTimingVisible(true);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
  }
  const onStudentSelected = function(value){
    setTimingVisible(false);
    setLoading(false);
    setStudent(value);
    var hasStu = false;
    if(value)if(value.id) hasStu = true;
    setBtnVisible(hasStu);
    setTimingVisible(hasStu);

  }
  return (
    <>
    {
      comboVisible?
      <Row>
        <Col md={3}>
          <StudentCombo value={student} onChange={(value)=>{ onStudentSelected(value.itemValue)}}  returnFullItem={true}/>
        </Col>
        <Col md={3} style={{paddingTop:"30px"}}>
          <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
            {btnVisible?<Button label="مشاهده برنامه" icon="pi pi-check" onClick={()=>{loadTimings(student.id)}} severity="success" iconPos="right" loading={loading} />: <></>}
          </div>          
        </Col>
      </Row>
      :<></>
    }
      {
        timingVisible?
        <div>
          {
            loading?
            <>loading...</>
            :
            <>
            <Container fluid>
              {
                schoolClass && schoolClass.id?
                <Row>
                  <Col>
                    کلاس: {schoolClass.name + ", " + schoolClass.field.title + ", پایه:" + util.getDegreeChar(schoolClass.degree)}
                  </Col>
                </Row>
                :<></>
              }
              <Row style={{overflow:"scroll", marginTop:"10px"}}>
                <table border="1" style={{borderCollapse:'collapse', width:'100%'}}>
                  <thead>
                    <tr>
                      <td style={{textAlign:"center", width:"70px", padding:"5PX", border:"1px solid #b0b0b0"}}>روز</td>
                      {
                        dayParts.map((zang) => {return (<td style={{textAlign:"center", backgroundColor:"#808080", color:"#fff", padding:"10px 5px"}}>{zang.title}</td>)})
                      }              
                    </tr>
                  </thead>
                  <tbody>
                    {timings.map((day) => 
                      <tr>
                        <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>{day.weekDayName}</td>
                        {
                        day.dayItems.map((col) => 
                          <td style={{padding:'10px', textAlign:'center', border:"1px solid #b0b0b0"}}>        
                                {
                                  col.timePartItems.map((cls)=>{
                                    return(
                                      (cls.course != null)&&(cls.course2 == null)?
                                      <div style={{border:"1px solid #02701eff", backgroundColor:"#daf7e3ff", color:"#000000", position:"relative"}}>
                                        {cls.teacher.firstname + " " + cls.teacher.lastname}
                                        <div style={{minWidth:"150px", border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                          <div title={cls.teacher.firstname + " " + cls.teacher.lastname + " - " + cls.course.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"center", fontSize:"8pt"}}>
                                            {cls.course.name}
                                          </div>
                                        </div>
                                      </div>
                                      :(cls.course != null)&&(cls.course2 != null)?
                                      <>
                                      <div style={{minWidth:"150px", border:"1px solid #faae82ff", backgroundColor:"#f7dbc5ff", color:"#000000", position:"relative"}}>
                                        {cls.teacher.firstname + " " + cls.teacher.lastname}
                                        <div style={{border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                          <div title={cls.teacher.firstname + " " + cls.teacher.lastname + " - " + cls.course.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"center", fontSize:"8pt"}}>
                                            {cls.course.name}
                                          </div>
                                        </div>
                                      </div>
                                      <div style={{minWidth:"150px", border:"1px solid #faae82ff", backgroundColor:"#f7dbc5ff", color:"#000000", position:"relative"}}>
                                        {cls.teacher2.firstname + " " + cls.teacher2.lastname}
                                        <div style={{border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                          <div title={cls.teacher2.firstname + " " + cls.teacher2.lastname + " - " + cls.course2.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"center", fontSize:"8pt"}}>
                                            {cls.course2.name}
                                          </div>
                                        </div>
                                      </div>
                                      </>
                                      :<></>
                                    )
                                  })
                                }
                          </td>)
                        }
                      </tr>)}
                  </tbody>
                </table>
              </Row>
            </Container>
            </>
          }
        </div>
        :
        <></>
      }
    </>
  );
}
